requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (!customElements.get('recently-viewed')) {
      class RecentlyViewed extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.slider = themeBase.isSlider(this);
          !this.slider ? this.init() : scriptController.executeWhenScriptLoaded('slider-component.js', () => this.init());
        }

        init() {
          let recentlyViewedProducts = [];

          try {
            const storageValue = localStorage.getItem('recentlyViewed');
            const parsedValue = storageValue ? JSON.parse(storageValue) : [];

            if (Array.isArray(parsedValue)) {
              recentlyViewedProducts = parsedValue;
            }
          } catch (error) {
            recentlyViewedProducts = [];
          }

          this.recentlyViewedProducts = recentlyViewedProducts;

          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            const handles = encodeURIComponent(this.recentlyViewedProducts.join(' '));

            fetch(`/collections/all?view=recently-viewed&handles=${handles}&products_to_show=${this.dataset.productsToShow}&sections=${this.dataset.sectionId}`)
              .then((response) => response.json())
              .then((text) => {
                const html = document.createElement('div');
                const sectionHtml = text[this.dataset.sectionId] || '';

                html.innerHTML = sectionHtml;

                const recentlyViewed = html.querySelector('recently-viewed');

                if (!recentlyViewed) {
                  console.error('[recently-viewed] Missing <recently-viewed> in section response', {
                    sectionId: this.dataset.sectionId,
                    keys: Object.keys(text)
                  });
                  return;
                }

                this.innerHTML = recentlyViewed.innerHTML;
                this.classList.add('recently-viewed--loaded');
                scriptController.executeWhenScriptLoaded('slider-component.js', () => {
                  const slider = this.querySelector('slider-component');

                  if (slider && typeof slider.resetPages === 'function') {
                    slider.resetPages();
                  }
                });
                window.dispatchEvent(new CustomEvent('MutationObserverLoaded'));
                window.lazyImages.find();
              })
              .catch((e) => {
                console.error(e);
              });
          };

          new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: '1000px 0px 1000px 0px'
          }).observe(this);
        }
      }

      customElements.define('recently-viewed', RecentlyViewed);
    }
  });
});